import { render, staticRenderFns } from "./loan.vue?vue&type=template&id=ea45722c&scoped=true&"
import script from "./loan.vue?vue&type=script&lang=js&"
export * from "./loan.vue?vue&type=script&lang=js&"
import style0 from "./loan.vue?vue&type=style&index=0&id=ea45722c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea45722c",
  null
  
)

export default component.exports